import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * 路由级错误兜底 —— 任何子组件抛错时,把真正的错误渲染到屏幕上,
 * 便于快速定位"白屏"问题
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // 同步输出到控制台,便于用户在 DevTools 中看到
    console.error('[ErrorBoundary]', error, info);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="card border-teamA-danger/30 bg-teamA-danger/5 m-3">
          <h1 className="text-base font-semibold text-teamA-danger">页面出错了</h1>
          <p className="mt-2 text-sm text-slate-700">{this.state.error.message}</p>
          <pre className="mt-3 max-h-80 overflow-auto whitespace-pre-wrap rounded-md bg-slate-50 p-3 text-xs text-slate-700">
{this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
